import {Component, Input, OnInit} from '@angular/core';
import { EDLGroupType, Group } from '@edl-development/edl-common';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';

/**
 * Modal component for toggling group selection.
 * Allows filtering groups by type and selecting/deselecting all.
 */
@Component({
    templateUrl: './toggle-group-modal.component.html',
    styleUrls: ['./toggle-group-modal.component.scss']
})
export class ToggleGroupModalComponent implements OnInit {
    private _groups: Group[] = [];
    private _filterGroupType?: EDLGroupType = null;

    filteredGroups: Group[] = [];

    @Input() title: string = 'Select Groups To Update';

    /**
     * Input setter for groups.
     * Triggers filtering whenever the input changes.
     */
    @Input()
    set groups(value: Group[]) {
        this._groups = value || [];
        this.applyFilter();
    }
    get groups(): Group[] {
        return this._groups;
    }

    /**
     * Input setter for filterGroupType.
     * Triggers filtering whenever the filter changes.
     */
    @Input()
    set filterGroupType(value: EDLGroupType | undefined) {
        this._filterGroupType = value;
        this.applyFilter();
    }
    get filterGroupType(): EDLGroupType | undefined {
        return this._filterGroupType;
    }

    constructor(
        public activeModal: NgbActiveModal,
    ) {}

    ngOnInit(): void {
        // Initial filtering based on the provided groups and filter type
        this.applyFilter();
    }
 
    /**
     * Applies the current filter to the groups.
     */
    private applyFilter() {
        this.filteredGroups = (this.filterGroupType != null && this.filterGroupType != undefined) ?
            this._groups.filter(g => g.Type === this.filterGroupType) :
            [...this._groups];
    }

    /**
     * Closes the modal and returns the filtered groups.
     * @param group The group to toggle.
     */
    ok() {
        this.activeModal.close(this.filteredGroups);
    }

    /**
     * Dismisses the modal without returning any data.
     */
    cancel() {
        this.activeModal.dismiss();
    }

    /**
     * Selects all groups in the filtered list.
     */
    selectalll() {
        this.filteredGroups.forEach(element => {
            element.IsSelected = true;
        });
    }

    /**
     * Deselects all groups in the filtered list.
     */
    deselectalll() {
        this.filteredGroups.forEach(element => {
            element.IsSelected = false;
        });
    }
}